import { createContext, useContext, useEffect } from "react";

export const PageTitleContext = createContext(null);

/**
 * Pone el título y la miga de pan desde la propia pantalla, cuando el de la ruta no
 * alcanza: el alta tiene dos pasos en la misma ruta y cada uno se llama distinto.
 *
 * Al desmontarse la pantalla se vuelve al título de la ruta, para que no se arrastre a la
 * siguiente página (el layout se reutiliza entre rutas hermanas).
 */
export const usePageTitle = (title, breadcrumb) => {
  const setPageTitle = useContext(PageTitleContext);

  useEffect(() => {
    if (!setPageTitle) return undefined;
    setPageTitle({ title, breadcrumb });
    return () => setPageTitle(null);
  }, [setPageTitle, title, breadcrumb]);
};
